import type React from 'react';

import { Separator, Spinner, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';
import { ClientRender } from '@change-corgi/core-react/ssr/render';

import { SignFormContainer } from '../signFormSunrise';
import { SignatureStatsActiveContainer } from '../stats/signatureStats';

const SideUnsignedContainerInner: React.FC = () => {
	return (
		<>
			<Text className="my-4" variant="heading" as="h2" size="small">
				<Translate value="corgi.petition_gamma.petition_sign.sign_title" />
			</Text>
			<div className="hidden md:block">
				<SignFormContainer />
			</div>

			<div className="block md:hidden">
				<Spinner className="mx-auto mt-16 size-6" />
			</div>
		</>
	);
};

export const SideUnsignedContainer: React.FC = () => {
	return (
		<>
			<div className="mb-4">
				<SignatureStatsActiveContainer />
			</div>
			<Separator />
			{/* using programmatic media query to allow lazy loading of the sign form in modal on mobile */}
			{/* Spinner is necessary for SSR */}
			<ClientRender placeholder={<Spinner className="mx-auto mt-16 size-6" />}>
				<SideUnsignedContainerInner />
			</ClientRender>
		</>
	);
};
